import {selectIsOnPrimaryLocale} from '@packages/systems/localization';
import {LOCALIZATION_LOCALE_TYPES} from '@packages/systems/localization-constants';
import type {DesignerStores} from '@packages/systems/designer/flux';
import {abilityFeature} from '../abilityFeature';

type StateSlice = {LocalizationStore: DesignerStores['LocalizationStore']};

export const getCurrentLocaleType = (state: StateSlice) => {
  return selectIsOnPrimaryLocale(state.LocalizationStore)
    ? LOCALIZATION_LOCALE_TYPES.PRIMARY
    : LOCALIZATION_LOCALE_TYPES.SECONDARY;
};

export const localization = abilityFeature({
  key: 'localization',
  isValid: function isLocalizationValid(state, config) {
    const currentLocaleType = getCurrentLocaleType(state);

    if (!config.currentLocaleType) return true;

    return Boolean(config.currentLocaleType[currentLocaleType]);
  },
});
